import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'container-padrao',
  templateUrl: './container-padrao.component.html',
  styleUrls: ['./container-padrao.component.css']
})
export class ContainerPadraoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
